/* eslint-disable require-jsdoc */
/* eslint-disable no-unused-expressions */

import React, {useEffect, useRef, useState} from 'react';
import PropTypes from 'prop-types';
import http from '../services/http';
import ListGroup from 'react-bootstrap/ListGroup';
import BeatLoader from 'react-spinners/BeatLoader';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faSearch} from '@fortawesome/free-solid-svg-icons';
import {Popover as BootstrapPop, OverlayTrigger} from 'react-bootstrap';
import { debug, pApiBase } from '../config';
function getQueryStr(minDate, maxDate, query, lat, lon) {
  const minDateStr = `?min_date=${minDate}`;
  const maxDateStr = `&max_date=${maxDate}`;
  const searchQueryStr = `&query=${query}`;
  const latStr = `&lat=${lat}`;
  const lonStr = `&lon=${lon}`;

  // if(!hasGenre){
  //   genreStr = `&genre=`;
  // }
  return (
    pApiBase + '/power-search' +
    minDateStr +
    maxDateStr +
    searchQueryStr +
    latStr +
    lonStr
  );
}

export default function Locations(props) {
  const [showLoc, setShowLoc] = useState(false);
  const [loading, setLoading] = useState(false);
  const [show, setShow] = useState(false);
  const [searchVal, setSearchVal] = useState(props.locationText);
  const [prevSearchVal, setPrevSearchVal] = useState(props.locationText);
  const [locations, setLocations] = useState([]);
  const searchRef = useRef(null);
  useEffect(()=>{
    if (searchRef.current) {
     debug && console.log("focus 1", searchRef.current);
      searchRef.current.focus();
    }
    debug && console.log("focus 12", searchRef);
  }, [searchRef, show]);

  debug && console.log('dist ', props.distance !== '');
  const clickedResult = (loc) => {
    // window.aMap.changeLocation(loc.lat, loc.lon);
    // window.aCarousel1.changeLocation(loc.lat, loc.lon);
    //setShow(!show);
   // window.aMap.changeLocation(loc.lat, loc.lon);
    props.setGeolocation(loc.name);
    // props.setLat(loc.lat);
    // props.setLon(loc.lon);
    props.setLoc({lat: loc.lat, lon: loc.lon})
    document.body.click();
   // window.aMap.changeLocation(loc.lat, loc.lon);
    debug && console.log('location clicked');
    debug && console.log('show is 1, ', show);
  }
 

  // debug && console.log('query str ', queryStr);
  const getResults = async (queryStr, newSearchVal) => {
    debug && console.log("get results search val ", newSearchVal !== undefined && newSearchVal.length > 0);
    if(newSearchVal !== undefined && newSearchVal.length > 0){
      try {
        setLoading(true);
        const response=await http.get(queryStr, true);
        setLoading(false);
        setLocations(response.results.locations); // set State
      } catch (err) {
        setLoading(true);
        console.error(err.message);
      }
  } 
  };
  const handleSubmit = () => {
    if(prevSearchVal !== searchVal){
      setPrevSearchVal(searchVal);
      const queryStr = getQueryStr(
        props.minDate,
        props.maxDate,
        searchVal,
        props.loc.lat,
        props.loc.lon
      );
      getResults(queryStr, searchVal);
    }

    };
    const handleChange = (e) => {
      setSearchVal(e.target.value);
    }
  const handleKeyUp = (e) => {
    if(e.key === 'Enter' && prevSearchVal !== searchVal){
      setPrevSearchVal(searchVal);
        const queryStr = getQueryStr(
          props.minDate,
          props.maxDate,
          searchVal,
          props.loc.lat,
          props.loc.lon
        );
        getResults(queryStr, searchVal);
    }
  };
  // <LocationsModal minDate={props.minDate} maxDate={props.maxDate} 
  // setLat={props.setLat} lat={props.lat} setLon={props.setLon} lon={props.lon} distance={10000} loading={loading} 
  // setLoading={setLoading} setShow={setShowLoc} show={showLoc} setGeolocation={props.setGeolocation} setShow={setShow} />
 const handleTrigger = () => {
   setShow(!show);
 }
  const popover = (
<BootstrapPop className="popover-location">
    <BootstrapPop.Title>
    <div className='hearby-powersearch-search hearby-powersearch-location-search-area'>
    <input 
     ref={searchRef}
     key="customsearchbar123"
     value={searchVal}
     placeholder={"Anywhere"}
     onKeyUp={handleKeyUp}
     onChange={handleChange}
    />
    <div className="hearby-powersearch-location-search-submit hearby-submit-search" onClick={handleSubmit}><button className="hearby-location-submit-button"><FontAwesomeIcon className="hearby-submit-button-icon" icon={faSearch}/></button></div>
    </div>
      </BootstrapPop.Title>
      <BootstrapPop.Content>
      <ListGroup variant="flush">
          {loading && <BeatLoader color={'#FF1744'} className="hearby-spinner"/>}
          {!loading && locations.map((location) => (
            <ListGroup.Item onClick={(e) => clickedResult(location)} key={location.name + location.distance}>
              <div className="hearby-location-result">
                <span className="hearby-search-results-location-name">
                  {location.name}
                </span>
                <span className="hearby-search-results-location-dist">
                  {location.distance.toFixed(1)} mi
                </span>
              </div>

            </ListGroup.Item>
          ))}
        </ListGroup>
        </BootstrapPop.Content>
  </BootstrapPop> 
  );

  return (
    <div className="hearby-powersearch-area hearby-powersearch-location">
      <div className="hearby-powersearch-title hearby-powersearch-location-title">Where?</div>
      <OverlayTrigger trigger='click' placement="bottom" overlay={popover} 
        rootClose={true} onToggle={handleTrigger} 
        popperConfig={{strategy: 'fixed'}} >
         <div 
            className="hearby-powersearch-text hearby-powersearch-location-text" 
            type="button"> {props.geolocation}
         </div> 
      </OverlayTrigger> 
    </div>
  );
}
Locations.propTypes = {
  minDate: PropTypes.string,
  maxDate: PropTypes.string,
  lat: PropTypes.number,
  lon: PropTypes.number,
  setLat: PropTypes.func,
  setLon: PropTypes.func,
  geolocation: PropTypes.string,
};